import type { CSSProperties } from "react";

/** Decorative bars; heights are CSS pixels fed to the `--bar` custom property. */
export function Waves({ bars }: { bars: number[] }) {
  return (
    <div className="sound-waves" aria-hidden="true">
      {bars.map((n, i) => <i key={i} style={{ "--bar": `${n}px` } as CSSProperties} />)}
    </div>
  );
}
